import { Timestamp } from '@griply/types';
import { format } from 'date-fns';

import { TimeProgressTickRange } from './get-time-progress-chart-ticks';

export const getTimeProgressTickFormatter = (
  tickRange: TimeProgressTickRange,
): ((date: Timestamp) => string) => {
  switch (tickRange) {
    case TimeProgressTickRange.Day:
      return (date) => format(date, 'iiiii');
    case TimeProgressTickRange.Week:
      return (date) => format(date, 'd');
    case TimeProgressTickRange.Month:
      return (date) => format(date, 'MMM d');
    case TimeProgressTickRange.Months:
      return (date) => format(date, 'LLLLL');
    case TimeProgressTickRange.MonthsWithYear:
      return (date) => format(date, "MMM ''yy");
  }
};
